import React from 'react';
import { filter } from 'lodash';

import { isEquipment } from '@/components/modals/SubmitOrder/constants';
import { ProductPricingType, ProductType } from '@/types';

import { useOrderContext } from '../../../helpers';
import { ProposalBlockWrapper } from '../ProposalBlockWrapper';

import { Props } from './types';

import styles from './ProposalDetails.module.scss';

export const ProposalDetails = ({
  proposal,
  homeownerAddress,
  shouldDisplayPurchaseNumber,
  purchaseNumber,
  orderItems,
}: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isAccessProgram && state.isDistribution;

  const proposalLink = {
    click: () => window.open(proposal.link ?? '', '_blank'),
    label: 'Download Proposal',
  };

  // calculate price per watt
  let pricePerWatt: number | null = null;

  const filterEquipment = filter(orderItems, oi => isEquipment(oi));

  if (filterEquipment.length) {
    const equipment = filterEquipment.find(
      product => product.priceBookEntry.product.type === ProductType['PV'],
    );

    if (
      equipment?.priceBookEntry?.pricePerWatt &&
      equipment?.priceBookEntry.pricingType === ProductPricingType['System Sized']
    ) {
      pricePerWatt = equipment?.priceBookEntry.pricePerWatt;
    }
  }

  return (
    <ProposalBlockWrapper link={proposalLink} title="proposal details">
      <div className={styles.order_details}>
        <div className={styles.order_detail}>
          <div className={styles.label}>Customer</div>
          <div className={styles.value}>
            {homeownerAddress.firstName}&nbsp;
            {homeownerAddress.lastName}
          </div>
        </div>
        <div className={styles.order_detail}>
          <div className={styles.label}>System Size</div>
          <div className={styles.value}>{proposal.systemSize?.toFixed(2)} kW</div>
        </div>
        {isActivityDistributionModel && (
          <div className={styles.order_detail}>
            <div className={styles.label}>SHINGLE QUANTITY</div>
            <div className={styles.value}>{proposal.timberlineShingles} Shingles</div>
          </div>
        )}
        <div className={styles.order_detail}>
          <div className={styles.label}>Proposal Name</div>
          <div className={styles.value}>{proposal.name}</div>
        </div>
        {pricePerWatt && (
          <div className={styles.order_detail}>
            <div className={styles.label}>PRICE/WATT</div>
            <div className={styles.value}>${pricePerWatt}</div>
          </div>
        )}
      </div>
      {shouldDisplayPurchaseNumber && purchaseNumber && (
        <div className={styles.order_details}>
          <div className={styles.order_detail}>
            <div className={styles.label}>PO Number</div>
            <div className={styles.value}>{purchaseNumber}</div>
          </div>
        </div>
      )}
    </ProposalBlockWrapper>
  );
};

export default ProposalDetails;
